import { FC, useState } from 'react'
import classes from './index.module.css'
import useIsTechSupport from './useIsTechSupport'
import { useChatContext } from '../ChatContext'
import { chatApi } from '@/api'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'

interface SupportChatButtonProps {}

const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="0.2"
    fill="none"
    className={classes.supportChatButtonIcon}
  >
    <path
      fill="currentColor"
      d="M12.942 18H11.5q-3.132 0-5.316-2.183T4 10.504t2.183-5.317T11.498 3q1.566 0 2.93.586q1.364.585 2.383 1.604t1.604 2.379T19 10.5q0 2.87-1.474 5.264t-3.753 3.98q-.134.077-.27.085q-.134.007-.257-.06t-.196-.171t-.079-.263zm1.058.35q1.775-1.5 2.888-3.512T18 10.5q0-2.725-1.888-4.612T11.5 4T6.888 5.888T5 10.5t1.888 4.613T11.5 17H14zm-2.464-2.779q.306 0 .52-.216t.213-.523t-.216-.52t-.523-.214t-.52.217t-.214.523t.216.52t.524.213M9.459 8.202q.174.067.347-.009t.283-.245q.205-.338.582-.54q.377-.2.868-.2q.736 0 1.197.385t.46 1.042q0 .406-.197.76q-.197.353-.672.828q-.644.627-.925 1.076t-.28.872q0 .197.128.336t.31.14t.305-.14q.123-.138.146-.341q.049-.31.335-.689t.696-.788q.564-.564.807-1.063q.243-.5.243-.999q0-1.029-.71-1.655t-1.805-.626q-.736 0-1.356.359t-.932.856q-.11.203-.065.388t.235.253m2.041 2.973"
    />
  </svg>
)

const SupportChatButton: FC<SupportChatButtonProps> = () => {
  const { isTechSupport, settings } = useIsTechSupport()
  const chatContext = useChatContext()
  const [isCreating, setIsCreating] = useState(false)

  const userId = useSelector(selectProfile)?.id

  const handleClick = async () => {
    if (!chatContext || !userId || isCreating) {
      return
    }

    setIsCreating(true)

    try {
      const response = await chatApi.createSupportChat({ user_id: userId })

      if (response.data?.data?.chat_id) {
        chatContext.changePage('inChat', response.data?.data?.chat_id)
        // Сбрасываем счетчик непрочитанных сообщений при открытии чата
        chatContext?.setUnreadSupportMessagesCount(0)
      }
    } catch (error) {
      console.error('Error creating/accessing support chat:', error)
    } finally {
      setIsCreating(false)
    }
  }

  if (isTechSupport || settings?.isTechSupportEnabled !== '1') {
    return null
  }

  if (!userId) {
    return null
  }

  return (
    <div
      className={classes.supportChatButton}
      onClick={handleClick}
      style={{
        opacity: isCreating ? 0.6 : 1,
        cursor: isCreating ? 'wait' : 'pointer',
      }}
    >
      <div className={classes.iconWrapper}>
        <SupportIcon />
        {chatContext && chatContext.unreadSupportMessagesCount > 0 && (
          <div className={classes.unreadBadge}>
            {chatContext.unreadSupportMessagesCount}
          </div>
        )}
      </div>
      <p className={classes.supportChatButtonText}>{`тех. \nподдержка`}</p>
    </div>
  )
}

export default SupportChatButton
